import {IonBadge, IonContent, IonItem, IonLabel, IonList, IonLoading, IonRefresher, IonRefresherContent} from '@ionic/react';
import React from 'react';
import {connect} from 'react-redux';
import {RouteComponentProps} from 'react-router';
import {actions, RootState} from '../store';
import "./DressageProtocolDetailPage.css"
import DressageProtocol from "../domain/DressageProtocol";
import DressageProtocolDetailHeader from "./components/DressageProtocolDetailHeader";
import DressageStep from "../domain/DressageStep";
import DressageLine from "../domain/DressageLine";
import StringUtils from "../utils/String.utils";
import {PayloadMetaAction} from "typesafe-actions/dist/types";
import CalendarItems from "../domain/CalendarItems";
import {PluginListenerHandle, Plugins} from "@capacitor/core";

type DressageProtocolDetailPageProps = RouteComponentProps<{ protocolId: string, tab: string }> & typeof mapDispatchToProps & {
  dressageProtocol?: DressageProtocol;
  lastUpdatedTimeStamp: Date;
  calendarItems: CalendarItems;
};
type State = {
  imagesVisible: boolean;
  isRefreshing: boolean;
  showLoading: boolean;
}

class DressageProtocolDetailPage extends React.Component<DressageProtocolDetailPageProps, State> {
  private ionRefresherRef: React.RefObject<HTMLIonRefresherElement>;
  private backButtonHandle ?: PluginListenerHandle;

  constructor(props: DressageProtocolDetailPageProps) {
    super(props);
    this.state = {
      isRefreshing: false,
      showLoading: false,
      imagesVisible: false,
    };
    props.updateDressageProtocolDetail(props.match.params.protocolId);
    this.ionRefresherRef = React.createRef<HTMLIonRefresherElement>();
  }

  componentDidMount(): void {
    this.backButtonHandle = Plugins.App.addListener('backButton', () => this.props.history.push("/dressage-protocols"));
    setTimeout(() => {
      if (this.props.dressageProtocol === undefined) {
        this.setState({showLoading: true})
      }
    }, 150);
    // @ts-ignore
    this._isUnMounting = false;
  }

  componentWillUnmount(): void {
    // @ts-ignore
    this._isUnMounting = true;
    this.backButtonHandle!.remove()
  }

  componentDidUpdate(prevProps: Readonly<RouteComponentProps<{ protocolId: string; tab: string }> & { updateDressageProtocolDetail: (protocolId: string) => PayloadMetaAction<string, string, undefined> } & { dressageProtocol?: DressageProtocol; lastUpdatedTimeStamp: Date }>, prevState: Readonly<State>, snapshot?: any): void {
    setTimeout(() => {
      if (this.props.dressageProtocol !== undefined && this.state.showLoading) {
        // @ts-ignore
        if(!this._isUnmounting){
          this.setState({showLoading: false})
        }
      }
      if (this.props.dressageProtocol === undefined && !this.state.showLoading) {
        // @ts-ignore
        if(!this._isUnmounting){
          this.setState({showLoading: true})
        }
      }
    }, 150);
  }

  private renderLoading() {
    return (
      <IonLoading
        isOpen={this.state.showLoading}
        onDidDismiss={() => {
        }}
        message={'Loading...'}
        duration={3000}
      />
    );
  }

  render() {
    if (!this.props.dressageProtocol) {
      const withoutSearchProps = {
        searchBarEnabled: false,
        initialChecked: false
      };
      return (
        <>
          <DressageProtocolDetailHeader {...this.props} {...withoutSearchProps} canGoBack={true}/>
          <IonContent>
            <IonRefresher ref={this.ionRefresherRef} onIonRefresh={this.doRefresh}>
              <IonRefresherContent/>
            </IonRefresher>
            <div className={"dressage-test-detail-content"}>
              {this.renderLoading()}
            </div>
          </IonContent>
        </>
      )
    }
    const withoutSearchProps = {
      searchBarEnabled: false,
      title: `${this.props.dressageProtocol.series}`,
      onToggleImageVisibility: (shouldBeVisible: boolean) => {
        this.setState({imagesVisible: !this.state.imagesVisible})
      },
      initialChecked: true
    };
    return (
      <>
        <DressageProtocolDetailHeader {...this.props} {...withoutSearchProps} canGoBack={true}/>

        <IonContent>
          <IonRefresher ref={this.ionRefresherRef} onIonRefresh={this.doRefresh}>
            <IonRefresherContent/>
          </IonRefresher>
          <div className={"dressage-test-detail-content"}>
            {this.renderLoading()}
            {this.renderProtocolDetailItem(this.props.dressageProtocol)}
          </div>
        </IonContent>
      </>
    );
  }

  renderProtocolDetailItem(item: DressageProtocol) {
    return (
      <IonList>
        {item.dressageSteps.map(s => this.renderStep(s))}
      </IonList>
    );
  }

  renderStep(step: DressageStep) {
    let index = 0;
    const imageUrl = step.imageUrl;
    let image = null;
    if (this.state.imagesVisible && imageUrl !== undefined) {
      image = (
        <img src={imageUrl} alt={imageUrl}/>
      )
    }
    return (
      <IonItem key={step.index}>
        <IonBadge class="dressage-protocol-period" slot="start">
          <p>{StringUtils.pad(step.index, 2)}</p>
        </IonBadge>
        <IonLabel class="label" text-wrap>
          <ul>
            {step.dressageLines.map((line: DressageLine) => this.renderLine(line, index++))}
          </ul>
          {image}
        </IonLabel>
      </IonItem>
    );
  }

  renderLine(line: DressageLine, index: number) {
    return (
      <li key={index} className={"dressage-line"}>
        <b>{line.direction}</b> {line.command}
      </li>
    );
  }

  doRefresh = () => {
    setTimeout(() => {
      this.setState(() => ({isRefreshing: true}));
      if (this.ionRefresherRef.current) {
        this.ionRefresherRef.current.complete();
      }
      this.props.updateDressageProtocolDetail(this.props.match.params.protocolId);
    }, 500);
  };
}

const mapStateToProps = (state: RootState) => {
  return {
    calendarItems: state.calendar.thisWeeksCalendarItems,
    lastUpdatedTimeStamp: state.dressageProtocol.lastUpdatedTimeStamp,
    dressageProtocol: state.dressageProtocol.dressageProtocol
  }
};

const mapDispatchToProps = {
  updateDressageProtocolDetail: (protocolId: string) => actions.dressageProtocol.updateDressageProtocol(protocolId)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DressageProtocolDetailPage);
